<template>
  <div>
    <b-col>
      <ProductCard class="col-md-12" :key="product.Item_id" :prodDetails="product" :filter="[]" />
    </b-col>
  </div>
</template>

<script>
import ProductCard from "./common-components/ProductCard";

export default {
  components: {
    ProductCard,
  },
  name: "RecommendationCard",
  methods: {
    goToProductPage() {
      this.$router.push({
        name: "Product",
        params: { id: this.product.Item_id },
      });
    },
  },
  props: ["product", "name", "item_id"],
};
</script>

<style scoped>
.img-container {
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  border-radius: 10px;
}

.img-container img {
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center center;
  cursor: pointer;
}

.title {
  height: auto;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>